// extracted by mini-css-extract-plugin
export default {"container":"LeadingContent-module__container__PnSMqNL","isSelectable":"LeadingContent-module__isSelectable__SGeW2Gh","centerAligned":"LeadingContent-module__centerAligned__p7czWeb"};